export default __webpack_public_path__ + "static/media/2.da8fe2c1.wav";